// AppInsights.js
import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { useEffect } from 'react';
import fetch from 'isomorphic-unfetch';

const config = {
  connectionString: `${process.env.NEXT_PUBLIC_APPLICATIONINSIGHTS_CONNECTION_STRING}`,
};

const filteringFunction = (envelope: ITelemetryItem) => {
  if (envelope?.baseType === 'ExceptionData') {
    if (envelope?.data?.message?.indexOf('Minified React error') > -1) {
      return false;
    }
    // Uncaught ReferenceError: fbq is not defined at HTMLBodyElement.value [as insertBefore]
    if (envelope?.data?.message?.indexOf('fbq is not defined') > -1) {
      return false;
    }
    // ReferenceError: Can't find variable: _AutofillCallbackHandler at global code
    if (envelope?.data?.message?.indexOf('_AutofillCallbackHandler') > -1) {
      return false;
    }
  }
  if (envelope?.baseData?.message?.indexOf('AI (Internal): 72') > -1) {
    return false;
  }
  return true;
};

const appInsights = new ApplicationInsights({
  config: config,
});
appInsights.addTelemetryInitializer(filteringFunction);
appInsights.loadAppInsights();

const logClientException = (error) => {
  appInsights.trackException({ error: error, severityLevel: SeverityLevel.Error });
};

const logClientMessage = (message) => {
  appInsights.trackTrace({ message: message });
};

const useAppInsightsTrackPageView = () => {
  useEffect(() => {
    appInsights.trackPageView({ name: location.pathname });
    console.log('trackPageView', location.pathname);
  }, [location?.pathname]);
};

// This feels a bit hacky to do this manually but seems to be the only way to log exceptions from
// getCustomInitialProps as NextJS won't allow server libs to be loaded there (seems to think its browser code)
const logServerException = async (error) => {
  try {
    const configPieces = config.connectionString.split(';');
    const iKey = configPieces[0].split('=')[1];
    let endpoint = configPieces[1].split('=')[1];

    let body = [
      {
        name: `Microsoft.ApplicationInsights.${iKey}.Exception`,
        time: new Date().toISOString(),
        iKey: iKey,
        tags: {},
        data: {
          baseType: 'ExceptionData',
          baseData: {
            ver: 2,
            exceptions: [
              {
                message: error.message,
                typeName: 'Error',
                stack: error.stack,
                hasFullStack: false,
                parsedStack: undefined,
              },
            ],
            severityLevel: 3,
            properties: {
              typeName: 'Error',
            },
          },
        },
      },
    ];

    const res = await fetch(endpoint + '/v2/track', { method: 'POST', body: JSON.stringify(body) });
    if (!res.ok) {
      throw new Error(`logServerException failed: ${res.status}`);
    }
  } catch (error) {
    console.error(error);
  }
};

export { useAppInsightsTrackPageView, logClientException, logClientMessage, logServerException };
